<template>
  <div class="container">
    <div class="col-md-12">
      <div class="prod-tit shops_list_block_tit">
        <h1>{{obData.messages.title}}</h1>
      </div>
      <div class="tabs row">
        <div class="col-md-12 tx-a-l head_tab_filter">
          <span class="tabItem" @click="setTab('adress')" :class="visibleTab==='adress'?'active':''">
            {{obData.messages.tabAdresaMagazinov}}
          </span>
<!--          <span class="tabItem" @click="setTab('map')" :class="visibleTab==='map'?'active':''">-->
<!--            {{obData.messages.tabOnMap}}-->
<!--          </span>-->
          <span>
            {{obData.messages.selectCityTitle}}:
            <div class="select_wraper">
              <select ref="citySelect">
                <option v-for="city in obData.citys" :value="city.link" :selected="city.selected">{{city.text}}</option>
              </select>
            </div>
          </span>

        </div>

      </div>
      <div class="tab adress" v-if="visibleTab==='adress'">
        <shops_list_item @setMapAndFocus="setMapAndFocus" v-for="item in obData.items" :item="item" :mess="obData.messages"/>
      </div>
<!--      <div class="tab map" v-if="visibleTab==='map'">-->
<!--        <div ref="map" class="mayMap"></div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Shops_list_item from "./shops_list_item.vue";

export default {
  name: "shops_list_block",
  components: {Shops_list_item},
  selector: '.shops_list_block',
  props:{params: Object},
  data() {
    return {
      obData:this.params,
      visibleTab:"adress",

    };
  },

  methods: {
    setCity(evt) {
      alert(JSON.stringify(evt));
    },
    setTab(newTab) {
      this.visibleTab = newTab;
      if(newTab=="map") {
        this.initMap ();
      }
    },
    setMapAndFocus(id) {
      this.setTab("map");
      this.initMap (id);
    },
    initMap (toPoint) {
      Vue.nextTick(() => {
        var mapElement = this.$refs.map;
        let kol = 0;
        let lg = 0;
        let ln = 0;
        var mapStyleZoomedOut = [
          {
            elementType: "geometry",
            stylers: [
              { hue: "#F8CBD8" },
              { lightness: 60 },
              { saturation: -20 }
            ]
          },{
            elementType: "labels",
            stylers: [
              { visibility: "on" },
              { hue: "#AA8B9E" },
              { lightness: 50 },
              { saturation: -20 }
            ]
          },
          {
            featureType: "road",
            elementType: "labels",
            stylers: [
              { saturation: -60 }
            ]
          }
        ];
        for(let i in this.obData.map.items) {
          let arr = this.obData.map.items[i].mapPoint.split(',');
          lg+=arr[0]*1;
          ln+=arr[1]*1;
          kol++;
        }
        lg/=kol;
        ln/=kol;
        const mapOptions = {
          zoom: 10,
          center: new google.maps.LatLng(lg, ln)
        }
        var map = new google.maps.Map(mapElement, mapOptions);
        var styledMapOptions = {map: map, name: 'minimial'};
        var sMapType = new google.maps.StyledMapType(mapStyleZoomedOut, styledMapOptions);
        map.mapTypes.set('minimal', sMapType);
        map.setMapTypeId('minimal');
        var infowindow = {};
        for(let i in this.obData.map.items) {
          let item = this.obData.map.items[i];

          let arr = item.mapPoint.split(',');
          let marker = new google.maps.Marker({
            position: new google.maps.LatLng(arr[0], arr[1]),
            map: map,
            icon: {
              url: 'https://brand.tous.com/storelocator/media/img/shoptype_1.png',
              size: new google.maps.Size(23, 40),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(11, 20),
            },
            animation: google.maps.Animation.DROP,
          });

          var contentString = '<div id="content">'+
              '<div id="siteNotice" style="text-align: center;"><a href="'+item.link+'"><img style="max-width: 180px;" src="'+item.picture+'"></a></div><br>'+
              '<h1 id="firstHeading" class="firstHeading">'+item.name+'</h1>'+
              '<div id="bodyContent">'+
              '<p>'+ item.text +'</p>'+
              '</div>'+
              '</div>';
          infowindow[item.id] = new google.maps.InfoWindow({content: contentString});
          marker.addListener("click", function() {
            infowindow[item.id].open(map.Map, marker);
          });
          if(item.id==toPoint) {
            infowindow[item.id].open(map.Map, marker);
            map.setCenter(new google.maps.LatLng(arr[0], arr[1]));
            map.setZoom(16);
          }
        }
      });
    }
  },
  mounted() {
    $(this.$refs['citySelect']).on("change",function () {
      location.href = $(this).val();
    })

  }
}
</script>

<style scoped>
  .mayMap {
    width: 100%;
    height: 90vh;
  }
  .select_wraper {
    display: inline-block;
    width: 200px;
    text-align: left;
  }
  .tx-a-r {
    text-align: right;
  }
  .tabItem {
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
  }
  .tabs {
    margin-bottom: 20px;
  }
  .tabItem.active {
    text-decoration: underline;
    color: red;
  }
  .tab.adress {
    flex-wrap: wrap;
    display: flex;
  }
  .tab {
    margin-bottom: 30px;
  }
  .head_tab_filter {
    display: flex;
    align-items: center;
  }
@media (max-width: 992px) {
  .prod-tit.shops_list_block_tit {
    margin-top: 20px;
  }
  .head_tab_filter span:last-child {
    margin-left: auto;
    display: block;
  }
}
@media (max-width: 768px) {
  .tx-a-r, .tx-a-l {
    text-align: center;
  }
  .col-md-7.tx-a-l {
    margin-bottom: 20px;
  }
  .prod-tit.shops_list_block_tit {
    margin-bottom: 20px;
  }
  .head_tab_filter {
    display: block;
  }
  .head_tab_filter span:last-child {
    margin-top: 20px;
  }
}
</style>